import React from "react";
import { Seo, Section, SectionHead, FadeUp } from "./Ui";
import { COMPANIES } from "./data";
import { CompanyCard } from "./DrezoroHome";

export default function DrezoroCompanies() {
  return (
    <div data-testid="drezoro-companies">
      <Seo title="Our Companies — DREZORO" description="The DREZORO brand family: Vozelto, TurnKey Property Maintenance, Black Ember Coffee, and Operation Enough — with room to grow." />
      <Section>
        <SectionHead label="Our Companies" title="Independent brands. Shared intelligence."
          intro="Every DREZORO company runs on the group's shared AI and automation foundations while serving its own market with total focus." />
        <div className="grid grid-cols-12 gap-6">
          {COMPANIES.map((c) => <CompanyCard key={c.id} c={c} tall />)}
        </div>
        <FadeUp className="mt-8">
          <div className="dz-card border-dashed !bg-transparent p-10 text-center" data-testid="dz-future-slot">
            <div className="dz-label mb-3">+ Future Companies</div>
            <p className="text-sm text-zinc-500 max-w-md mx-auto">
              The DREZORO portfolio is engineered to expand. New ventures are announced in the newsroom as they launch.
            </p>
          </div>
        </FadeUp>
      </Section>
    </div>
  );
}
